import styled from '@emotion/styled';

import {
  breakpoints,
  charcoalGrey,
  darkGrey,
  fontWeight,
  pinkishOrange,
  turquoise,
} from '~/src/styles';

export const parsedArticleBodyStyles = `
  img {
    max-width: 100%;
  }

  .image-block{
    text-align: center;
      &.left{
        text-align: left;
      }
    }

  p {
    font-size: 1rem;
    font-weight: 400;
    line-height: 1.75;
    letter-spacing: 0.5px;
  }

  a,
  a:hover {
    color: ${pinkishOrange};
  }

  h2,
  h3 {
  text-transform: uppercase;
    font-size: 20px;
  font-weight: ${fontWeight.semiBold};
    line-height: 1.33;
    letter-spacing: -0.3px;
    margin: 30px 0 16px;
  }

  h4 {
  font-size: 1.125rem;
  font-weight: ${fontWeight.medium};
  line-height: 1.56;
  color: ${charcoalGrey};
    font-size: 0.9rem;
    margin-top: 30px;
    margin-bottom: 16px;
  }

  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    color: ${turquoise};
    text-transform: uppercase;
    font-weight: ${fontWeight.bold};
  }

  h6 {
    font-size: 12px;
  }

  ul {
  font-size: 18px;
  line-height: 1.5;

    list-style-type: none;
    padding: 16px 0 16px 50px;
  }

  li {
    padding: 10px 0;
    position: relative;
    font-weight: 300;
    font-size: 0.9rem;

    &::before {
      content: '•';
      position: absolute;
      font-size: 30px;
      left: -30px;
      top: -3px;
    }
  }

  blockquote p {
    font-size: 16px;
    font-weight: ${fontWeight.semiBold};
    line-height: 1.5;
    color: ${pinkishOrange};
    text-align: center;
    padding: 30px 50px;
  }
`;

export const ArticleBodyWrapper = styled.div`
  font-size: 16px;
  font-weight: ${fontWeight.regular};
  line-height: 25px;
  letter-spacing: 0.03em;
  text-align: left;
  color: ${darkGrey};
  padding: 16px 16px 0;
  max-width: 764px;
  ${breakpoints.minTablet} {
    width: 640px;
    margin: auto;
    margin-top: 24px;
  }
  ${breakpoints.minDesktop} {
    width: 100%;
    margin-top: 32px;
  }
  ${parsedArticleBodyStyles}
`;
